import { makeStyles, useTheme } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import WarningIcon from "@material-ui/icons/Warning";
import React, { createContext } from "react";
import { useTranslation } from "react-i18next";

export const ALERT_TYPE = {
  MESSAGE: "message",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  ERROR: "error",
};

export const AlertContext = createContext({
  isOpen: false,
  showAlert: (
    info = {
      type: ALERT_TYPE.MESSAGE,
      title: "",
      description: "",
      button: [{ title: "Close" }],
    }
  ) => {},
  hideAlert: () => {},
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyle = makeStyles((theme) => ({
  wrapTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  titleSpacer: {
    width: theme.spacing(2),
  },
}));

export default function AlertProvider({ children }) {
  const classes = useStyle();
  const theme = useTheme();
  const { t } = useTranslation();
  const [isOpen, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState({
    type: ALERT_TYPE.MESSAGE,
    title: "",
    description: "",
    button: [{ title: t("close") }],
  });

  const showAlert = (info) => {
    setMessage({ ...message, ...info });
    setOpen(true);
  };

  const hideAlert = () => {
    setOpen(false);
  };

  const getTitleIcon = () => {
    switch (message.type) {
      case ALERT_TYPE.ERROR:
        return <ErrorIcon />;
      case ALERT_TYPE.SUCCESS:
        return <CheckCircleIcon />;
      case ALERT_TYPE.INFO:
        return <InfoIcon />;
      case ALERT_TYPE.WARNING:
        return <WarningIcon />;
      default:
        return null;
    }
  };

  const getTitleColor = () => {
    switch (message.type) {
      case ALERT_TYPE.ERROR:
        return theme.palette.error.main;
      case ALERT_TYPE.SUCCESS:
        return theme.palette.success.main;
      case ALERT_TYPE.INFO:
        return theme.palette.info.main;
      case ALERT_TYPE.WARNING:
        return theme.palette.warning.main;
      default:
        return null;
    }
  };

  const titleIcon = getTitleIcon();

  return (
    <AlertContext.Provider
      value={{
        isOpen,
        showAlert,
        hideAlert,
      }}
    >
      <div>
        {children}
        <Dialog
          open={isOpen}
          TransitionComponent={Transition}
          keepMounted
          fullWidth
          maxWidth="xs"
          // onClose={hideAlert}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>
            <div
              className={classes.wrapTitle}
              style={{ color: getTitleColor() }}
            >
              {titleIcon ? (
                <>
                  {titleIcon}
                  <div className={classes.titleSpacer} />
                </>
              ) : null}
              {message.title}
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {message.description}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {message.button.map((button, index) => (
              <Button
                key={index}
                color="primary"
                onClick={() => {
                  hideAlert();
                  if (button.onClick) button.onClick();
                }}
                {...button.buttonProps}
              >
                {button.title}
              </Button>
            ))}
          </DialogActions>
        </Dialog>
      </div>
    </AlertContext.Provider>
  );
}
